import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useCommentsQuery } from "../../../../hooks/useCommentsQuery";
import Segment from "../../../navigation/Segment/Segment";
import { SegmentItem } from "../../../../types/interfaces/navigation";
import { BackComponent } from "../../../../hooks/useSafeNavigation";
import { Stack, Button, Text } from "@primer/react";
import { ChevronLeftIcon } from "@primer/octicons-react";

interface AdViewSegmentProps {
  id: string;
}

const AdViewSegment: React.FC<AdViewSegmentProps> = ({ id }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    isLoading: isLoadingComments,
    data: commentsData,
    refetch: refetchAComments,
  } = useCommentsQuery(
    id, // entityId
    "ad", // entityType
    false, // is_admin
    1, // page
    1 // limit
  );

  const userTabsData: SegmentItem[] = useMemo(() => [
    {
      text: "Объявление",
      href: "/ads/ad?id=" + id,
      isDisabled: false
    },
    {
      text: commentsData && commentsData.totalCount
        ? `Вопрос/ответ (${commentsData.totalCount})`
        : "Вопрос/ответ",
      href: "/ads/faq?id=" + id,
      isDisabled: false
    },
  ], [id, commentsData?.totalCount]);

  useEffect(() => {
    if (commentsData === undefined) {
      refetchAComments();
    }
  }, []);

  return (
    <Stack justify="space-between" direction="horizontal">
      <Stack direction="horizontal">
        <BackComponent fallbackPath="/ads" isOnlyFallback={false} />
        <Segment items={userTabsData} />
      </Stack>
    </Stack>
  );
};

export default AdViewSegment;